<template>
	<v-dialog
		:value="value"
		max-width="800px"
		@input="$emit('input', $event)"
	>
		<v-card>
			<v-container>
				<h1 class="headline">Keyword Suggestions</h1>
				<v-autocomplete
					v-model="keywordList"
					:items="keywordLists"
					label="Keyword List"
					item-text="name"
					return-object
					persistent-hint
					no-data-text="No Keyword Lists"
				/>
				<div class="text-xs-center">
					<span
						v-for="keyword in keywordListKeywords"
						:key="keyword.id"
					>
						<v-chip
							:color="isActiveKeyword(keyword.keyword) ? 'secondary' : 'primary'"
							dark
							@click="changeKeyword(keyword.keyword)"
						>
							{{ keyword.keyword }}
						</v-chip>
					</span>
					<span v-if="keywordListKeywords.length === 0" class="title">No Keywords</span>
				</div>
				<div class="title mt-3 mb-2">{{ article.title }}</div>
				<v-card>
					<template v-if="keywordParagraphs.length !== 0" >
						<v-layout row align-center>
							<v-checkbox
								v-model="context"
								label="More Context"
								color="secondary"
								class="mt-0 ml-3"
								hide-details
							/>
							<v-btn
								flat
								@click="setSummary(currentParagraph)"
							>
								Set as Summary
							</v-btn>
						</v-layout>
						<v-divider/>
					</template>
					<v-window v-model="currentParagraph">
						<v-window-item
							v-for="(paragraph, index) in keywordParagraphs"
							:key="index"
						>
							<v-layout
								row
								wrap
								fill-height
								tag="v-card-text"
							>
								<div v-html="highlight(contextParagraph(paragraph))" class="preserve-whitespace"/>
							</v-layout>
						</v-window-item>
					</v-window>
					<v-divider v-show="keywordParagraphs.length !== 0"/>
					<v-card-actions class="justify-space-between">
						<v-btn
							flat
							:disabled="keywordParagraphs.length < 2"
							@click="prev"
						>
							<v-icon>chevron_left</v-icon>
						</v-btn>
						<span v-if="keywordParagraphs.length > 0">
							{{ currentParagraph + 1 }}/{{ keywordParagraphs.length }}
						</span>
						<span v-else>No Keywords Found</span>
						<v-btn
							flat
							:disabled="keywordParagraphs.length < 2"
							@click="next"
						>
							<v-icon>chevron_right</v-icon>
						</v-btn>
					</v-card-actions>
				</v-card>
				<!-- <div v-html="highlightBody" class="preserve-whitespace"></div> -->
				<div class="text-xs-center">
					<v-btn
						flat
						color="error"
						class="mt-3"
						@click="$emit('input', false)"
					>
						Close
					</v-btn>
				</div>
			</v-container>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		value: { type: Boolean, required: true },
		article: { type: Object, default: null },
	},
	data() {
		return {
			content: this.article.body,
			keywordList: null,
			keyword: '',
			currentParagraph: 0,
			context: false,
		};
	},
	computed: {
		keywordLists() {
			return this.$store.get('keywordLists')
				.sort((a, b) => a.name.localeCompare(b.name));
		},
		keywordListKeywords() {
			if (!this.keywordList || this.keywordList.length === 0) {
				return [];
			}
			return this.keywordList.keywords;
		},
		// highlightBody() {
		// 	if (!this.keyword) {
		// 		return this.content;
		// 	}
		// 	return this.content.replace(new RegExp(this.keyword, 'gi'),
		// 		match => (`<span class="yellow">${match}</span>`));
		// },
		keywordParagraphs() {
			if (!this.keyword || !this.content) {
				return [];
			}
			const regex = new RegExp(this.keyword, 'i');
			// this.content.split(/[.?!]/)
			const paragraphs = this.content.split(/[\n]/)
				.filter(paragraph => (regex.test(paragraph)));
			return paragraphs;
		},
		paragraphs() {
			if (!this.keyword) {
				return [];
			}
			const paragraphs = this.content.split(/[\n]/)
				.filter(content => (content.trim()));
			return paragraphs;
		},
	},
	watch: {
		// Select first keyword on list change
		keywordList(val) {
			if (val && val.keywords && val.keywords.length > 0) {
				this.keyword = val.keywords[0].keyword;
			}
		},
	},
	created() {
		// Select default keywordlist
		if (this.keywordLists && this.keywordLists.length > 0) {
			this.keywordList = this.keywordLists.find(list => (list.isDefault));
		}
	},
	methods: {
		highlight(content) {
			return content.replace(new RegExp(this.keyword, 'gi'),
				match => (`<span class="yellow">${match}</span>`));
		},
		contextParagraph(paragraph) {
			if (!this.context) {
				return paragraph;
			}
			const index = this.paragraphs.indexOf(paragraph);
			const list = [];
			if (index > 0) {
				list.push(this.paragraphs[index - 1]);
			}
			list.push(paragraph);
			if (index < this.paragraphs.length - 1) {
				list.push(this.paragraphs[index + 1]);
			}
			return list.join('\n\n');
		},
		changeKeyword(keyword) {
			this.keyword = keyword;
			this.currentParagraph = 0;
		},
		isActiveKeyword(keyword) {
			return this.keyword === keyword;
		},
		next() {
			this.currentParagraph = this.currentParagraph + 1 === this.keywordParagraphs.length
				? 0
				: this.currentParagraph + 1;
		},
		prev() {
			this.currentParagraph = this.currentParagraph - 1 < 0
				? this.keywordParagraphs.length - 1
				: this.currentParagraph - 1;
		},
		setSummary(paragraphIndex) {
			const paragraph = this.keywordParagraphs[paragraphIndex];

			if (this.context) {
				this.article.summary = this.contextParagraph(paragraph);
			}
			else {
				this.article.summary = paragraph;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.preserve-whitespace {
	white-space: pre-wrap;
}
</style>
